import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import {
  CasoTareaModel,
  CasoTareaService,
} from 'src/app/services/casos_tareas.service';
import { CaseInfo } from 'src/app/modules/cases/interfaces/cases-data.interface';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { CrearCasoTareasComponent } from '../../crear-caso/c-caso.component';
import { first } from 'rxjs/operators';
import { SecondaryInformationComponent } from '../secondary-information/secondary-information.component';
import { AgregarTareasComponent } from '../../agregar-tareas/agregar-tareas.component';
import { ComentarioSolicitarRevisionComponent } from '../comentario-solicitar-revision/comentario-solicitar-revision.component';
import { TareaCasoService } from 'src/app/services/tareacaso.service';
import { ApprovalByCase } from '../utils/approvalByCase';
import { PermisosService } from 'src/app/services/permisos.service';
import { RolesPermisosService } from 'src/app/services/roles_permisos.service';
import { RolService } from 'src/app/services/rol.service';
import { resolve } from 'dns';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { AskApprovalComponent } from './ask-approval/ask-approval.component';
import { CasesService } from 'src/app/core/services/cases.service';
import { CreateCaseComponent } from 'src/app/modules/cases/components/create-case/create-case.component';
interface Information {
  title: Texts;
  text: string;
  expanded?: boolean;
}

enum Texts {
  unit = 'Unidad',
  type = 'Tipo de caso',
  status = 'Estado',
  number = 'Número de caso',
  asignTo = 'Responsable',
  date = 'Fecha de creación',
  description = 'Descripción del caso',
  observation = 'Observación del gerente',
  remitido = 'Remitido de',
}

@Component({
  selector: 'app-case-information',
  templateUrl: './case-information.component.html',
  styleUrls: ['./case-information.component.scss'],
})
export class CaseInformationComponent implements OnInit {
  public Texts = Texts;
  public showMore: boolean = false;
  @Input() canRequestRevision: boolean;

  @ViewChild(SecondaryInformationComponent)
  secondaryInformation: SecondaryInformationComponent;
  private remitido: CasoTareaModel;
  constructor(
    private readonly casesService: CasoTareaService,
    private readonly route: ActivatedRoute,
    private readonly dialog: MatDialog,
    private router: Router,
    private readonly cd: ChangeDetectorRef,
    private readonly _tareacaso: TareaCasoService,
    private readonly rol: RolService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        // this.getInformation();
      }
    });
    // this.getInformation();
  }

  get needApproval() {
    return this.approvalByCase?.needApproval;
  }

  async getCaso() {
    const id = this.route.snapshot.paramMap.get('id');
    const caso = await this.casesService.getById(id).pipe(first()).toPromise();
    return caso;
  }
  async addTasks() {
    const caso = await this.getCaso();
    const dialogExist = this.dialog.getDialogById('message-pop-up');
    if (!dialogExist) {
      this.dialog.open(AgregarTareasComponent, {
        width: '1000px',
        height: '600px',
        data: caso,
        disableClose: true,
        id: 'message-pop-up',
        panelClass: 'relative-modal',
      });
    }
  }

  open(option) {
    this.showMore = true;
    this.cd.detectChanges();
    this.secondaryInformation.selected = this.secondaryInformation.Tabs[option];
  }

  // getInformation() {
  //   const id = this.route.snapshot.paramMap.get('id');
  //   this.casesService.getCaseInformation(id).subscribe({
  //     next: (information: any) => {
  //       this.setInformation(information);
  //     },
  //     error: () => {
  //       this.back();
  //     },
  //   });
  // }

  information: CaseInfo;
  approvalByCase: ApprovalByCase;
  async edit() {
    const caseData = await this.getCaso();

    // const dialogRef = this.dialog.open(CreateCaseComponent, {
    //   data: { edit: true, ...caseData },
    //   disableClose: true,
    //   panelClass: 'modalVerTarea',
    //   width: '600px',
    // });
    // dialogRef.afterClosed().subscribe(async () => {
    //   this.getInformation();
    // });
  }

  firstBlock: Information[];
  secondBlock: Information[];
  thirdBlock: Information[];

  setInformation(information: CaseInfo) {
    this.approvalByCase = null;
    this.information = information;
    this.approvalByCase = new ApprovalByCase(information, this.rol);
    // this.firstBlock = [
    //   {
    //     title: Texts.unit,
    //     text: information.caseType.unit.name,
    //   },
    //   {
    //     title: Texts.type,
    //     text: information.caseType.name,
    //   },
    //   {
    //     title: Texts.status,
    //     text: information.status,
    //   },
    // ];

    this.secondBlock = [
      {
        title: Texts.number,
        text: information.gai,
      },
      {
        title: Texts.asignTo,
        text: information.assigned.fullname,
      },
      {
        title: Texts.date,
        text: moment(information.createdAt).format('d/MM/yyyy h:mm a	'),
      },
    ];
    this.thirdBlock = [
      {
        title: Texts.description,
        text: information.description,
        expanded: false,
      },
      {
        title: Texts.observation,
        text: information.comentRevision,
        expanded: false,
      },
    ];
    // if (information.casoRemitido) {
    // this.casoService.getById(information.casoRemitido).subscribe((response)=>{
    //   this.remitido = response
    //   console.log(response)
    //   this.thirdBlock.push({
    //     title: Texts.remitido,
    //     text: response.numero_caso,
    //     expanded: false,
    //   })
    // })
    // }
  }

  get canAddTask() {
    return true;
    return ['En ejecución'].includes(this.information?.status);
  }
  public back() {
    window.history.go(-1);
  }

  ngOnInit() {}

  isEllipsisActive(e) {
    const styles = getComputedStyle(e);
    const widthEl = parseFloat(styles.width);
    const ctx = document.createElement('canvas').getContext('2d');
    ctx.font = `${styles.fontSize} ${styles.fontFamily}`;
    const text = ctx.measureText(e.innerText);
    return text.width > widthEl;
  }

  @Output() reload: EventEmitter<any> = new EventEmitter();
  async requestApproval() {
    // const caso = await this.getCaso();

    const response = (await this.getComment()) as string;

    // if (response) {
    //   this._tareacaso
    //     .requestApproval(caso._id, {
    //       comment: response,
    //       user: `${sessionStorage.getItem('correo')}`,
    //     })
    //     .subscribe({
    //       next: () => {
    //         this.showMessageSucess(
    //           'Solicitud de Aprobación realizada con éxito'
    //         );
    //         this.reload.emit();
    //         this.getInformation();
    //       },
    //     });
    //   return;
    // }
  }
  showMessageSucess(title) {
    this.dialog.open(SuccessComponent, {
      data: {
        title,
      },
      minWidth: '300px',
    });
  }

  async getComment() {
    return new Promise((resolve) => {
      const ref = this.dialog.open(ComentarioSolicitarRevisionComponent, {
        width: '90vw',
        maxWidth: '800px',
        maxHeight: '95vh',
        disableClose: true,
        panelClass: 'modalVerTarea',
      });
      ref.afterClosed().subscribe((response) => {
        resolve(response);
      });
    });
  }

  approval() {
    this.dialog
      .open(AskApprovalComponent, {
        minWidth: '400px',
      })
      .afterClosed()
      .subscribe(async (response) => {
        if (response) {
          this._tareacaso
            .acceptApproval(this.information._id, {
              user: `${sessionStorage.getItem('correo')}`,
            })
            .subscribe({
              next: () => {
                this.reload.emit();

                this.showMessageSucess('El caso ha sido aprobado');
                // this.getInformation();
              },
            });
        }
      });
  }
  async reject() {
    const response = (await this.getComment()) as string;

    if (response) {
      this._tareacaso
        .rejectApproval(this.information._id, {
          comment: response,
          user: `${sessionStorage.getItem('correo')}`,
        })
        .subscribe({
          next: () => {
            // this.getInformation();

            this.reload.emit();
            this.showMessageSucess('El caso ha sido rechazado');
          },
        });
      return;
    }
  }

  gotoCase(title) {
    if (title == Texts.remitido) {
      this.router.navigate([`../../casos/detalle/${this.remitido._id}`]);
    }
  }
}
